module.exports = __webpack_public_path__ + "img/verify.a4941025.svg";